export default "__VITE_ASSET__gD0QphhU__"